import { render, staticRenderFns } from "./EditVat.vue?vue&type=template&id=4ce79c3e&"
import script from "./EditVat.vue?vue&type=script&lang=js&"
export * from "./EditVat.vue?vue&type=script&lang=js&"
import style0 from "./EditVat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports